<template>
  <div>

      <h2 class="title">
        <awesomeIcon icon="exchange-alt"/>
        Geld overmaken
      </h2>

      <!-- iban -->
      <div class="subheader">Uw tegenrekening</div><br />
      <template
        v-if="
          ($parent.intake.goalData.type == 'levensonderhoud' && modelValue.goalData.box == '1')
          || $parent.intake.goalData.type == 'gouden-handdruk-uitkerend'
          || $parent.intake.goalData.type == 'netto-lijfrente-uitkerend'
        "
      >
        U ontvangt straks uw uitkering van uw beleggingsrekening bij
        {{ $parent.intakeAdmin.beleggen.brand }}.nl. Wij koppelen daarvoor hieronder uw
        bankrekening als vaste tegenrekening aan uw beleggingsrekening.
      </template>
      <template
        v-else-if="
          $parent.intake.goalData.type == 'netto-lijfrente-opbouwend'
          || $parent.intake.goalData.type == 'pensioen'
        "
      >
        U kunt straks geld overmaken naar uw beleggingsrekening bij
        {{ $parent.intakeAdmin.beleggen.brand }}.nl. Wij koppelen daarvoor hieronder uw
        bankrekening als vaste tegenrekening aan uw beleggingsrekening.
      </template>
      <template
        v-else-if="$parent.intake.goalData.type == 'gouden-handdruk-opbouwend'"
      >
        Om uw identiteit vast te stellen gebruiken wij een storting van een gelijknamige
        tegenrekening. Wij koppelen daarvoor hieronder uw bankrekening als vaste tegenrekening
        aan uw beleggingsrekening.
      </template>
      <template v-else>
        U kunt straks geld overmaken van of naar uw beleggingsrekening bij
        {{ $parent.intakeAdmin.beleggen.brand }}.nl met uw bankrekening.
        Wij koppelen uw bankrekening als vaste tegenrekening aan uw beleggingsrekening.
      </template>
      <br><br><div class="msg">
        Uw vaste tegenrekening moet
        {{ $parent.intake.rekeningData.type === 'Minderjarige rekening'
          ? 'dezelfde naam hebben als de ouder(s)/voogd(en) (volmacht) van'
          : 'dezelfde eigenaar of eigenaren hebben als'
        }}
        de beleggingsrekening bij {{ $parent.intakeAdmin.beleggen.brand }}.nl.
      </div>
      <customInput
        ref="iban"
        v-model="modelValue.rekeningData.iban"
        type="text"
        label="Tegenrekening (IBAN)"
        :validation="['required', 'iban']"
      />
      <span v-if="checkIbanSame" class="msg error">
        <awesomeIcon icon="exclamation-circle" />
        Vaste tegenrekening mag niet hetzelfde zijn als het rekeningnummer van een overdracht.
        Verander een van beide.
        <customInput
          v-show="false"
          type="text"
        />
      </span>
      <customInput
        type="yesno"
        v-model="modelValue.goalData.collect"
        :label="`Uw periodieke storting van € ${modelValue.goalData.stortingenBedrag},-
          ${modelValue.goalData.stortingenInterval.toLowerCase()} verloopt via automatische
          incasso`"
        v-if="
          $parent.intake.goalData.type != 'levensonderhoud'
          && $parent.intake.goalData.type != 'gouden-handdruk-uitkerend'
          && $parent.intake.goalData.type != 'netto-lijfrente-uitkerend'
          && ($parent.intake.goalData.stortingen == 'Yes'
            && Number($parent.intake.goalData.stortingenBedrag) > 0)
        "
        @changed="$parent.redo ? $parent.changingCollect() : ''"
      />

      <!-- afschrift -->
      <template
        v-if="filter(modelValue.persoonsData, financeFilter).length > 1 && !$parent.redo"
      >
        <div class="subheader">Kopie van een bankafschrift</div><br />
        U vraagt een rekening aan met meerdere rekeninghouders. Om straks uw
        identificatiestorting te kunnen controleren, hebben we een kopie van
        een bankafschrift nodig met daarop de namen van alle rekeninghouders.
        <customInput
          v-model="modelValue.accountFiles"
          type="file"
          :files="files"
          prefix="accountcopy"
          :validation="['files']"
        />
      </template>

      <!-- leefrente -->
      <template
        v-if="
          (modelValue.goalData.type == 'levensonderhoud' && modelValue.goalData.box == '1')
          || (modelValue.goalData.type == 'netto-lijfrente-uitkerend' && !$parent.redo)
        "
      >
        <div class="subheader">
          Uw uitkeringen
          ({{ $parent.intake.goalData.type == 'netto-lijfrente-uitkerend' ? 'Netto' : '' }}
          {{
            offerSelected && (offerSelected.offerType == '1' ||  offerSelected.offerType == '4')
            ? 'Leefrente' : 'Standaard Uitkerende Lijfrente'
          }})
        </div><br>
        <template v-if="modelValue.goalData.type != 'netto-lijfrente-uitkerend'">
          <strong>Inhoudingen op uw uitkering</strong><br>
          Standaard houden wij geen rekening met de loonheffingskorting. Dit is een korting op de
          belasting die u betaalt. Die korting wordt meestal al verwerkt in de AOW. Bij het wel
          toepassen moet u aan het eind van het jaar mogelijk belasting bijbetalen.<br>
          <br>
          <customInput
            v-model="$parent.intake.rekeningData.loonheffingskorting"
            type="yesno" label="Wilt u loonheffingskorting wel toepassen?"
          />
          <br>
        </template>
        <template v-if="!$parent.redo">
          <strong>Uitkering startdatum</strong><br>
          U kunt hieronder als indicatie een startmaand aangeven. Uw Leefrente
          beleggingsrekening start in deze maand en nadat uw startkapitaal door ons is ontvangen.
          Ontvangen wij uw startkapitaal later, dan wordt ook de startdatum later.
          Blijkt uw totale startkapitaal uiteindelijk hoger of lager te zijn? Dan berekenen we
          opnieuw de uitkering. Wij sturen u daarover geen extra bericht.
          <br><br>
          <customInput
            :validation="['notrequired']"
            v-model="$parent.intake.rekeningData.paymentStart"
            type="dropdown" label="Wanneer zou u willen beginnen met uitkeren?" :options="[
              { label: 'Zo snel mogelijk', value: '0', },
              { label: futureMonthName($parent.created, 1), value: '1', },
              { label: futureMonthName($parent.created, 2), value: '2', },
              { label: futureMonthName($parent.created, 3), value: '3', },
              { label: futureMonthName($parent.created, 4), value: '4', },
              { label: futureMonthName($parent.created, 5), value: '5', },
              { label: futureMonthName($parent.created, 6), value: '6', },
              { label: futureMonthName($parent.created, 7), value: '7', },
              { label: futureMonthName($parent.created, 8), value: '8', },
              { label: futureMonthName($parent.created, 9), value: '9', },
              { label: futureMonthName($parent.created, 10), value: '10', },
              { label: futureMonthName($parent.created, 11), value: '11', },
            ]"
          />
          <br>
        </template>
        <template v-if="modelValue.goalData.type != 'netto-lijfrente-uitkerend'">
          <strong>Uitzondering loonheffing</strong><br>
          U kunt ons vragen om rekening te houden met bijvoorbeeld premies en stortingen
          die u niet hebt afgetrokken van de belasting. Daarvoor dient u ons een kopie van uw
          saldoverklaring toe te sturen. Of misschien heeft u een andere brief van de
          belastingdienst.<br>
          <br>
          <customInput
            v-model="$parent.intake.rekeningData.uitzonderingloonheffing"
            type="yesno" label="Heeft u een uitzondering op uw loonheffing?"
          />
          <div
            v-if="modelValue.rekeningData.uitzonderingloonheffing == 'Yes'"
          >
            <customInput
              v-model="$parent.intake.rekeningData.exemptionFiles"
              type="file"
              :files="files"
              prefix="exemptionform"
              :validation="['files']"
            />
            <customInput
              v-model="$parent.intake.rekeningData.uitzonderingloonheffingBedrag"
              type="money"
              label="Hoe hoog is het bedrag waarvoor u van loonheffing bent uitgezonderd?"
              :validation="['notrequired']"
              placeholder="€"
            />
            <customInput
              v-model="$parent.intake.rekeningData.uitzonderingloonheffingDatum"
              type="date"
              label="Tot welke datum heeft u een uitzondering van loonheffing?"
              :validation="['notrequired']"
            />
          </div>
        </template>
      </template>

      <!-- gouden handdruk -->
      <template
        v-if="modelValue.goalData.type == 'gouden-handdruk-uitkerend'"
      >
        <div class="subheader">
          Gouden Handdruk
          {{offerSelected && offerSelected.offerType == '2' ? 'Vaste Looptijd' : 'Vaste Uitkering'}}
        </div><br>
        <strong>Inhoudingen op uw uitkering</strong><br>
        Standaard houden wij geen rekening met de loonheffingskorting. Dit is een korting op de
        belasting die u betaalt. Die korting wordt meestal al verwerkt in de AOW. Bij het wel
        toepassen moet u aan het eind van het jaar mogelijk belasting bijbetalen.<br>
        <br>
        <customInput
          v-model="$parent.intake.rekeningData.loonheffingskorting"
          type="yesno" label="Wilt u loonheffingskorting wel toepassen?"
        />
        <template v-if="!$parent.redo">
          <br><strong>Uitkering startdatum</strong><br>
          U kunt hieronder als indicatie een startmaand aangeven. Dit kan uiterlijk binnen
          12 maanden na aanvang zijn. Uw Gouden Handdruk beleggingsrekening start in die
          maand en nadat uw startkapitaal door ons is ontvangen.
          Blijkt uw totale startkapitaal uiteindelijk hoger of lager te zijn? Dan berekenen we
          opnieuw de uitkering bij de gewenste looptijd. Wij sturen u daarover geen extra bericht.
          <br><br>
          <customInput
            :validation="['notrequired']"
            v-model="$parent.intake.rekeningData.paymentStart"
            type="dropdown" label="Wanneer zou u willen beginnen met uitkeren?" :options="[
              { label: 'Zo snel mogelijk', value: '0', },
              { label: futureMonthName($parent.created, 1), value: '1', },
              { label: futureMonthName($parent.created, 2), value: '2', },
              { label: futureMonthName($parent.created, 3), value: '3', },
              { label: futureMonthName($parent.created, 4), value: '4', },
              { label: futureMonthName($parent.created, 5), value: '5', },
              { label: futureMonthName($parent.created, 6), value: '6', },
              { label: futureMonthName($parent.created, 7), value: '7', },
              { label: futureMonthName($parent.created, 8), value: '8', },
              { label: futureMonthName($parent.created, 9), value: '9', },
              { label: futureMonthName($parent.created, 10), value: '10', },
              { label: futureMonthName($parent.created, 11), value: '11', },
            ]"
          />
        </template>
      </template>

      <!-- kapitaal overdracht -->
      <template v-if="modelValue.goalData.box == '1' && (!$parent.redo || $parent.role > 7)">
        <div class="subheader">
          Startkapitaal {{ $parent.redo && $parent.role > 7 ? '(admin)' : ''}}
        </div><br>
        <template v-if="
          $parent.intake.goalData.type == 'pensioen'
          || $parent.intake.goalData.type == 'netto-lijfrente-opbouwend'
        ">
          U heeft aangegeven dat u gaat starten met €
          {{formatPrice(Number($parent.intake.goalData.vermogen), true)}}.
          Standaard noteren wij uw gehele startbedrag als uw fiscale jaar- en/of
          reserveringsruimte. Dit is correct als u het startbedrag zelf overmaakt. U kunt ook
          kapitaal laten overdragen door een andere partij. Dat heeft invloed op uw jaar- en
          reserveringsruimte. U kunt kapitaal laten overdragen door één van de volgende partijen:
        </template>
        <template v-else>
          U gaat starten met € {{formatPrice(Number($parent.intake.goalData.vermogen), true)}}
          dat bij ons binnenkomt vanuit een andere partij, dit kan vanuit de volgende partijen:
        </template>
        <ol>
          <li>
            Verzekeringsmaatschappij (lopende of expirerende polis)
          </li>
          <li v-if="
            $parent.intake.goalData.type === 'levensonderhoud'
            || $parent.intake.goalData.type === 'pensioen'
            || $parent.intake.goalData.type === 'gouden-handdruk-opbouwend'
            || $parent.intake.goalData.type === 'gouden-handdruk-uitkerend'
          ">
            Eigen bedrijf (opgebouwd bedrag)
          </li>
          <li>
            Interne overboeking vanuit Doelbeleggen portefeuille
          </li>
          <li>
            Overig (banksparen, vermogensbeheerder)
          </li>
        </ol>
        Laat u kapitaal overdragen door een andere partij? Selecteer dan via de groene knop(pen)
        waar uw startbedrag vandaan komt. Dan zorgen wij voor een overboekingsformulier. U kunt
        meerdere kapitaaloverdrachten toevoegen.

      <modalWindow
        v-if="overdrachtModal"
        @close="overdrachtModal = false"
        width="700"
      >
        <template v-slot:close><a>Opslaan</a></template>
        <div
          v-if="modelValue.transferData.overdrachten[index].overdrachtType === 'bv'"
          class="titlebar"
        >
          Overdracht vanuit uw bedrijf
        </div>
        <div
          v-else-if="modelValue.transferData.overdrachten[index].overdrachtType === 'intern'"
          class="titlebar"
        >
          Interne overboeking vanuit Doelbeleggen portefeuille
        </div>
        <div v-else class="titlebar">
          {{modelValue.transferData.overdrachten[index].overdrachtType === 'psk'
            ? 'Overdracht vanuit een polis'
            : 'Overdracht vanuit overige'}}
        </div>

        <div class="inset">
          <div class="flex-container flex-grow">
            <strong v-if="modelValue.transferData.overdrachten[index].overdrachtType === 'intern'">
              Doelbeleggen zal intern voor u de stukken overzetten naar uw nieuwe rekening. Vul het
              gewenste bedrag en het huidige portefeuillenummer in.
            </strong>
            <strong v-else>
              Om de overdracht correct uit te voeren, vragen wij u om onderstaande informatie in te
              vullen.
            </strong>
            <customInput
              v-if="modelValue.transferData.overdrachten[index].overdrachtType === 'bv'"
              type="dropdown" label="Type kapitaal"
              v-model="modelValue.transferData.overdrachten[index].kapitaalType"
              :options="
                $parent.intake.goalData.type === 'gouden-handdruk-opbouwend'
                || $parent.intake.goalData.type === 'gouden-handdruk-uitkerend'
                ? [{label:'Stamrecht', value:'Stamrecht'}]
                : [
                  {label:'FOR', value:'FOR'},
                  {label:'ODV', value:'ODV'},
                  {label:'Stakingswinst', value:'Stakingswinst'},
                  {label:'Stamrecht', value:'Stamrecht'},
                ]
              "
            />
            <customInput
              v-if="modelValue.transferData.overdrachten[index].overdrachtType === 'psk'"
              type="text"
              label="Polisnummer"
              v-model="modelValue.transferData.overdrachten[index].polisnummer"
            />
            <template
              v-if="modelValue.transferData.overdrachten[index].overdrachtType !== 'intern'"
            >
              <customInput
                v-if="modelValue.transferData.overdrachten[index].overdrachtType !== 'bv'"
                type="dropdown"
                :options="filter($parent.bankNames, (o) => o.value !== 'DB')"
                :label="'Instelling naam'
                "
                v-model="modelValue.transferData.overdrachten[index].instellingNaam"
              />
              <customInput
                v-else
                type="text"
                :label="'KVK-nummer'"
                v-model="modelValue.transferData.overdrachten[index].instellingNaam"
              />
            </template>
            <customInput
              v-if="
                modelValue.transferData.overdrachten[index].overdrachtType !== 'bv'
                && modelValue.transferData.overdrachten[index].instellingNaam == 'Anders'
              "
              v-model="
                modelValue.transferData.overdrachten[index].instellingNaamOmschrijving
              "
              type="text" :validation="['required']"
              :label="'Naam instelling'"
            />
            <customInput
              v-model="modelValue.transferData.overdrachten[index].bedrag" type="money"
              label="Bedrag"
              :validation="['min']"
            />
          </div>
          <div class="flex-container flex-grow">
            <customInput
              v-if="modelValue.transferData.overdrachten[index].overdrachtType !== 'psk'"
              :state="false"
              ref="iban"
              v-model="modelValue.transferData.overdrachten[index].iban"
              type="text"
              :label="modelValue.transferData.overdrachten[index].overdrachtType === 'bv'
              ? 'Bedrijfsrekeningnummer (IBAN)'
              : modelValue.transferData.overdrachten[index].overdrachtType === 'intern'
                ? 'Doelbeleggen portefeuillenummer'
                : 'Rekeningnummer van instelling'"
              :validation="
                modelValue.transferData.overdrachten[index].overdrachtType === 'psk2'
                || modelValue.transferData.overdrachten[index].overdrachtType === 'intern'
                ? ['required']
                : ['required', 'iban']"
            />
          </div>
          <span
            v-if="
              ['bv', 'psk2'].includes(
                modelValue.transferData.overdrachten[index].overdrachtType
              ) && modelValue.transferData.overdrachten[index].kapitaalType !== 'Stakingswinst'
            "
            class="msg"
          >
            <awesomeIcon icon="exclamation-circle" />
            <span>
              Vaste tegenrekening mag niet hetzelfde zijn als het rekeningnummer van een overdracht.
            </span>
          </span>
          <template
            v-if="
              modelValue.transferData.overdrachten[index].overdrachtType !== 'psk2'
              && modelValue.transferData.overdrachten[index].overdrachtType !== 'intern'
            "
          >
            <br><strong>
              {{
                modelValue.transferData.overdrachten[index].overdrachtType === 'bv'
                ? `Relevante documentatie (
                    ${relevantDocs(modelValue.transferData.overdrachten[index].kapitaalType)}
                  )`
                : 'Polisblad'
              }}
            </strong>
            <div class="msg">
              <ul style="padding-left:13px; margin:0px;">
                <li>
                  Let op, het document moet het volgende bestandsformaat zijn: .jpg, .jpeg, .png,
                  .pdf, .doc, .docx
                </li>
              </ul>
            </div>
            <customInput
              v-model="modelValue.transferData.overdrachten[index].files"
              type="file"
              :prefix="`overdrachten-${Number(index)}-polis`"
              :validation="modelValue.transferData.overdrachten[index].overdrachtType === 'bv'
              ? ['files']
              : ['files', 'max']"
              :max="1"
              :level="3"
            />
          </template>
        </div>
      </modalWindow>

      <div class="flex-container flex-grow">
        <strong
          v-if="$parent.role > 7 || !$parent.redo"
          style="margin-top: 20px;"
        >
          Kapitaal toevoegen:
        </strong>
        <button
          style="margin: 10px;margin-right: 0px;"
          v-if="$parent.role > 7 || !$parent.redo"
          @click="
            index = modelValue.transferData.overdrachten.push({
              index: modelValue.transferData.overdrachten.length,
              overdrachtType: 'psk',
            }) - 1;
            overdrachtModal=true;
          "
        >
          1. Vanuit een polis
        </button> &nbsp;
        <button
          style="margin: 10px;margin-right: 0px;"
          v-if="
            (
              $parent.intake.goalData.type === 'levensonderhoud'
              || $parent.intake.goalData.type === 'pensioen'
              || $parent.intake.goalData.type === 'gouden-handdruk-opbouwend'
              || $parent.intake.goalData.type === 'gouden-handdruk-uitkerend'
            ) && (
              !$parent.redo || $parent.role > 7
            )
          "
          @click="
            index = modelValue.transferData.overdrachten.push({
              index: modelValue.transferData.overdrachten.length,
              overdrachtType: 'bv',
            }) - 1;
            overdrachtModal=true;
          "
        >
          2. Vanuit uw bedrijf
        </button> &nbsp;
        <button
          style="margin: 10px;margin-right: 0px;"
          @click="
            index = modelValue.transferData.overdrachten.push({
              index: modelValue.transferData.overdrachten.length,
              overdrachtType: 'intern',
            }) - 1;
            overdrachtModal=true;
          "
        >
          {{(
            $parent.intake.goalData.type === 'levensonderhoud'
            || $parent.intake.goalData.type === 'pensioen'
            || $parent.intake.goalData.type === 'gouden-handdruk-opbouwend'
            || $parent.intake.goalData.type === 'gouden-handdruk-uitkerend'
          ) && (
            !$parent.redo || $parent.role > 7
          ) ? 3 : 2}}. Vanuit Doelbeleggen
        </button> &nbsp;
        <button
          style="margin: 10px;margin-right: 0px;"
          v-if="$parent.role > 7 || !$parent.redo"
          @click="
            index = modelValue.transferData.overdrachten.push({
              index: modelValue.transferData.overdrachten.length,
              overdrachtType: 'psk2',
            }) - 1;
            overdrachtModal=true;
          "
        >
          {{(
            $parent.intake.goalData.type === 'levensonderhoud'
            || $parent.intake.goalData.type === 'pensioen'
            || $parent.intake.goalData.type === 'gouden-handdruk-opbouwend'
            || $parent.intake.goalData.type === 'gouden-handdruk-uitkerend'
          ) && (
            !$parent.redo || $parent.role > 7
          ) ?  4 : 3}}. Vanuit overige
        </button>
      </div>

      <div class="table-wrapper">
        <table>
          <thead class="table-legend">
            <tr>
              <th>Type</th>
              <th>Instelling</th>
              <th>IBAN / Polis</th>
              <th>Bedrag</th>
              <th>Document</th>
              <th
                v-if="
                  (
                    $parent.role > 7
                    && ($parent.status === 'Ingeleverd' || $parent.status === 'Bezig')
                  )
                  || (!$parent.redo && $parent.status === 'Bezig')
                "
              >
              </th>
              <th
                v-if="
                  (
                    $parent.role > 7
                    && ($parent.status === 'Ingeleverd' || $parent.status === 'Bezig')
                  )
                  || (!$parent.redo && $parent.status === 'Bezig')
                "
              >
              </th>
            </tr>
          </thead>
          <tr
            v-for="(
              overdracht, overdrachtIndex) in
              filter(modelValue.transferData.overdrachten, 'bedrag'
            )"
            :key='overdrachtIndex'
          >
            <!-- Kapitaal type logic -->
            <td v-if="overdracht.overdrachtType === 'psk' || overdracht.overdrachtType === 'psk2'">
              PSK
            </td>
            <td v-else-if="overdracht.overdrachtType === 'intern'">
              Intern
            </td>
            <td v-else-if="overdracht.kapitaalType">
              {{overdracht.kapitaalType}}
            </td>
            <td v-else class="red">
              ?
              <customInput
                v-show="false"
                type="text"
              />
            </td>

            <!-- Instelling logic -->
            <td v-if="overdracht.overdrachtType === 'intern'">
              Doelbeleggen
            </td>
            <td
              v-else-if="
                !overdracht.instellingNaam
                || (
                  !overdracht.instellingNaamOmschrijving
                  && overdracht.instellingNaam === 'Anders'
                )
              "
              class="red"
            >
              {{
                (overdracht.overdrachtType === 'psk' || overdracht.overdrachtType === 'psk2' )
                  ? 'Instelling niet opgegeven'
                  : 'Uit bedrijf: KVK niet opgegeven'
              }}
              <customInput
                v-show="false"
                type="text"
              />
            </td>
            <td v-else-if="overdracht.overdrachtType === 'bv'">
              Uit bedrijf: KVK {{overdracht.instellingNaam}}
            </td>
            <td v-else>
              {{ overdracht.overdrachtType === 'psk' ? 'Polis:' : 'Overig: '}}
              {{
                overdracht.instellingNaam === 'Anders'
                  ? overdracht.instellingNaamOmschrijving
                  : overdracht.instellingNaam
              }}
            </td>

            <td v-if="overdracht.overdrachtType === 'psk' && overdracht.polisnummer">
              {{overdracht.polisnummer}}
            </td>
            <td
              v-else-if="
                !checkIban(overdracht.iban) && overdracht.iban
                && overdracht.overdrachtType === 'bv'
              "
              class="red"
            >
              Onjuist IBAN
              <customInput
                v-show="false"
                type="text"
              />
            </td>
            <td v-else-if="
              overdracht.iban || overdracht.overdrachtType === 'psk2'
            ">
              {{overdracht.iban || ''}}
            </td>
            <td v-else class="red">
              ?
              <customInput
                v-show="false"
                type="text"
              />
            </td>
            <td v-if="Number(overdracht.bedrag) > 0">
              &euro;&nbsp;{{ formatPrice(overdracht.bedrag, true)}}
            </td>
            <td v-else class="red">
              &euro;&nbsp;0,-
              <customInput
                v-show="false"
                type="text"
              />
            </td>

            <td v-if="
              overdracht.overdrachtType === 'psk2'
              || overdracht.overdrachtType === 'intern'
            ">
            </td>
            <td v-else-if="overdracht.files">
              <awesomeIcon class="green" icon="check" />
            </td>
            <td v-else>
              <awesomeIcon class="red" icon="exclamation-circle" />
              <customInput
                v-show="false"
                type="text"
              />
            </td>
            <td
              v-if="
                ($parent.role > 7 &&
                  ($parent.status === 'Ingeleverd' || $parent.status === 'Bezig')
                )
                || (!$parent.redo && $parent.status === 'Bezig')
              "
            >
              <a
                @click.stop
                @click="index = overdracht.index;overdrachtModal=true"
                style="cursor: pointer;"
              >
                Wijzigen <awesomeIcon icon="search"/>
              </a>
            </td>
            <td
              v-if="
                ($parent.role > 7 &&
                  ($parent.status === 'Ingeleverd' || $parent.status === 'Bezig')
                )
                || (!$parent.redo && $parent.status === 'Bezig')
              "
            >
              <a
                @click.stop
                @click="removeTransfer(overdracht.index)"
                style="cursor: pointer;"
              >
                Verwijderen <awesomeIcon icon="times"/>
              </a>
            </td>
          </tr>
          <tr v-if="
            (
              $parent.intake.goalData.type === 'pensioen'
              || $parent.intake.goalData.type === 'netto-lijfrente-opbouwend'
            )
            && Number($parent.intake.goalData.vermogen)
            - Number(sumBy(
              filter(modelValue.transferData.overdrachten, 'bedrag'),
              o => Number(o.bedrag),
            )) > 0
          ">
            <td> jaar/reserveringsruimte</td>
            <td>Zelf</td>
            <td>Vaste tegenrekening</td>
            <td>&euro;&nbsp;{{
              formatPrice(
              Number($parent.intake.goalData.vermogen)
              - Number(sumBy(
                filter(modelValue.transferData.overdrachten, 'bedrag'),
                o => Number(o.bedrag),
              )), true)
            }}</td>
            <td
              :colspan="
                ($parent.role > 7
                  && ($parent.status === 'Ingeleverd' || $parent.status === 'Bezig')
                ) || (!$parent.redo && $parent.status === 'Bezig')
                ? '4'
                : '1'
              "
            />
          </tr>
        </table>
      </div>

      <p
        class="msg"
        v-if="
          ( $parent.intake.goalData.type === 'pensioen'
            || $parent.intake.goalData.type === 'netto-lijfrente-opbouwend'
          )
          && Number($parent.intake.goalData.vermogen)
          - Number(sumBy(
            filter(modelValue.transferData.overdrachten, 'bedrag'),
            o => Number(o.bedrag),
          )) > 72550
      ">
        <awesomeIcon icon="exclamation-circle" />
        Uw huidige bedrag (&euro;&nbsp;{{
            formatPrice(
              Number($parent.intake.goalData.vermogen)
                - Number(sumBy(
                  filter(modelValue.transferData.overdrachten, 'bedrag'),
                  o => Number(o.bedrag),
                )), true)
          }}) is wellicht hoger dan het bedrag dat u maximaal aan jaar/reserveringsruimte kunt
          gebruiken. Controleer voor de zekerheid hoeveel jaar/reserveringsruimte u kunt gebruiken.
          Indien u kapitaal vanuit een overdracht wilt toevoegen, kunt u dat via de groene knop(pen)
          hierboven doen. U kunt ook uw inleg van uw doel wijzigen.<br />
          <u @click="$parent.intake.step = 1" style="cursor: pointer">
            Wijzig hier uw inleg bij uw doel.
          </u>
        </p>
        <p
          class="msg"
          v-else-if="$parent.intake.goalData.box === '1'
          && Number($parent.intake.goalData.vermogen)
            - Number(sumBy(
              filter(modelValue.transferData.overdrachten, 'bedrag'),
                o => Number(o.bedrag),
            )) < 0
        ">
          <awesomeIcon icon="exclamation-circle" />
          Uw overdracht bedrag (&euro;&nbsp;{{
            formatPrice(
              Number(sumBy(
              filter(modelValue.transferData.overdrachten, 'bedrag'),
              o => Number(o.bedrag),
            )), true)
          }}) is hoger dan de inleg (&euro;&nbsp;{{
            formatPrice(Number($parent.intake.goalData.vermogen), true)
          }}) die u bij uw doel heeft ingevuld.
          <u
            v-if="
              $parent.intake.goalData.type !== 'levensonderhoud'
              && $parent.intake.goalData.type !== 'gouden-handdruk-uitkerend'
              && $parent.intake.goalData.type !== 'netto-lijfrente-uitkerend'
            "
            @click="$parent.intake.step = 1"
            style="cursor: pointer"
          >
            Wijzig hier uw inleg bij uw doel.
          </u>
        </p>
        <p
          class="msg"
          v-else-if="
            ( $parent.intake.goalData.type === 'gouden-handdruk-opbouwend'
              || $parent.intake.goalData.type === 'levensonderhoud'
              || $parent.intake.goalData.type === 'gouden-handdruk-uitkerend'
              || $parent.intake.goalData.type === 'netto-lijfrente-uitkerend'
            )
            && Number(sumBy(
                filter(modelValue.transferData.overdrachten, 'bedrag'),
                o => Number(o.bedrag),
              )) === 0
        ">
          <awesomeIcon icon="exclamation-circle" />
          U heeft nog geen overdrachten. Voeg een overdracht (of meerdere) toe wat gelijk is aan uw
          doel bedrag (&euro;&nbsp;{{formatPrice(Number($parent.intake.goalData.vermogen), true)}}).
        </p>
        <p
          class="msg"
          v-else-if="
            ( $parent.intake.goalData.type === 'gouden-handdruk-opbouwend'
              || $parent.intake.goalData.type === 'levensonderhoud'
              || $parent.intake.goalData.type === 'gouden-handdruk-uitkerend'
              || $parent.intake.goalData.type === 'netto-lijfrente-uitkerend'
            )
            && Number($parent.intake.goalData.vermogen)
            - Number(sumBy(
              filter(modelValue.transferData.overdrachten, 'bedrag'),
                o => Number(o.bedrag),
            )) > 0
        ">
          <awesomeIcon icon="exclamation-circle" />
          Uw overdracht bedrag (&euro;&nbsp;{{
            formatPrice(
              Number(sumBy(
              filter(modelValue.transferData.overdrachten, 'bedrag'),
              o => Number(o.bedrag),
            )), true)
          }}) is lager dan de inleg (&euro;&nbsp;{{
            formatPrice(Number($parent.intake.goalData.vermogen), true)
          }}) die u bij uw doel heeft ingevuld.
          <template
            v-if="
              $parent.intake.goalData.type !== 'levensonderhoud'
              && $parent.intake.goalData.type !== 'gouden-handdruk-uitkerend'
              && $parent.intake.goalData.type !== 'netto-lijfrente-uitkerend'
            "
          >
            Indien u geen overdrachten meer toe gaat voegen, moet u uw doel wijzigen.
          </template>
          <u
            v-if="
              $parent.intake.goalData.type !== 'levensonderhoud'
              && $parent.intake.goalData.type !== 'gouden-handdruk-uitkerend'
              && $parent.intake.goalData.type !== 'netto-lijfrente-uitkerend'
            "
            @click="$parent.intake.step = 1"
            style="cursor: pointer"
          >
            Wijzig hier uw inleg bij uw doel.
          </u>
        </p>
        <template
          v-if="!$parent.redo && filter(
            modelValue.transferData.overdrachten,
            (o) =>
              (o.overdrachtType === 'psk' || o.overdrachtType === 'psk2')
              && Number(o.bedrag) > 0
              && (
                o.instellingNaam === 'NationaleNederlanden'
                || o.instellingNaam === 'Scildon'
              )
          ).length > 0"
        >
          <div class="subheader">Kopie bankafschrift</div>
          <div class="flex-container flex-grow">
            <div class="msg">
              <b>
                Om uw overdracht in behandeling te laten nemen door uw verzekeraar dienen wij ook
                een kopie van uw bankafschrift toe te sturen.
              </b>
              <ul style="padding-left:13px; margin:5px 0;">
                <li>Bankafschrift mag niet ouder dan 3 maanden zijn</li>
                <li>
                  Maak een duidelijke kopie of screenshot van een bankafschrift
                  met dezelfde tenaamstelling
                  ({{ modelValue.persoonsData[0].voorletters || '?' }}
                    {{ modelValue.persoonsData[0].tussenvoegsel }}
                    {{ modelValue.persoonsData[0].achternaam || '?' }})
                </li>
                <li>
                  Let op, het document moet het volgende bestandsformaat zijn: .jpg, .jpeg, .png,
                  .pdf, .doc, .docx
                </li>
              </ul>
            </div>
            <customInput
              v-model="modelValue.transferData.copyBankStatement"
              type="file"
              :prefix="`kopie-bankafschrift`"
              :validation="['files']"
            />
          </div>
        </template>
      </template>

  </div>
</template>

<script>
import { filter, sumBy, some } from 'lodash-es';

export default {
  name: 'IntakeTransfersPage',
  emits: ['update:model-value'],
  props: {
    modelValue: Object,
  },
  computed: {
    checkIbanSame() {
      return some(this.modelValue.transferData.overdrachten, (overdracht) => ['bv', 'psk2'].includes(overdracht.overdrachtType)
        && overdracht.kapitaalType !== 'Stakingswinst'
        && overdracht.iban === this.modelValue.rekeningData.iban
        && Number(overdracht.bedrag) > 0);
    },
    value() {
      return this.modelValue;
    },
    files() {
      return this.$parent.files;
    },
    offerSelected() {
      let selectedOffer = {};
      if (this.modelValue.goalData.type === 'netto-lijfrente-uitkerend') {
        selectedOffer = filter(
          this.modelValue.offers,
          (o) => (o.offerType === '4' || o.offerType === '5') && o.selected,
        );
      } else if (this.modelValue.goalData.type === 'gouden-handdruk-uitkerend') {
        selectedOffer = filter(
          this.modelValue.offers,
          (o) => (o.offerType === '2' || o.offerType === '3') && o.selected,
        );
      } else {
        selectedOffer = filter(
          this.modelValue.offers,
          (o) => (o.offerType === '0' || o.offerType === '1') && o.selected,
        );
      }
      if (selectedOffer[0]) {
        return Object.assign(
          selectedOffer[0],
          this.$parent.intakeAdmin.offers[selectedOffer[0].offerId],
        );
      }
      return selectedOffer[0];
    },
  },
  methods: {
    filter,
    sumBy,
    checkIban(iban) {
      let sum = String(iban);
      sum = sum.replace(/ /gi, '');
      sum = sum.replace(' ', '');
      if (sum.length < 15) {
        return false;
      }

      sum = sum.slice(4) + sum.slice(0, 4);
      const letters = {
        a: 10,
        b: 11,
        c: 12,
        d: 13,
        e: 14,
        f: 15,
        g: 16,
        h: 17,
        i: 18,
        j: 19,
        k: 20,
        l: 21,
        m: 22,
        n: 23,
        o: 24,
        p: 25,
        q: 26,
        r: 27,
        s: 28,
        t: 29,
        u: 30,
        v: 31,
        w: 32,
        x: 33,
        y: 34,
        z: 35,
      };
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(letters)) {
        sum = sum.replace(new RegExp(key, 'gi'), value);
      }

      // eslint-disable-next-line
      function iso7064Mod97_10(iban) {
        let remainder = iban;
        let block;

        while (remainder.length > 2) {
          block = remainder.slice(0, 9);
          remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
        }
        return parseInt(remainder, 10) % 97;
      }

      sum = iso7064Mod97_10(sum);
      return sum === 1;
    },
    futureMonthName(startDate, i) {
      const date = new Date(startDate);
      date.setDate(2);
      date.setMonth(new Date(startDate).getMonth() + i);
      return `Niet eerder dan ${
        new Date(date).toLocaleString('nl-NL', { year: 'numeric', month: 'long' })
      }`;
    },
    financeFilter(o) {
      return this.$parent.financeFilter(o);
    },
    relevantDocs(type) {
      if (type === 'Stamrecht') {
        return 'stamrechtovereenkomst, jaarrekening';
      }
      if (type === 'FOR') {
        return 'jaarrekening, eventuele aangifte';
      }
      if (type === 'ODV') {
        return 'ODV overeenkomst, jaarrekening';
      }
      if (type === 'Stakingswinst') {
        return 'stakingsakte, jaarrekening';
      }
      return 'bv. een jaarrekening';
    },
    removeTransfer(id) {
      if (
        this.modelValue.transferData.overdrachten[id].overdrachtType !== 'polis'
        && this.modelValue.transferData.overdrachten[id].overdrachtType !== 'polis2'
      ) {
        this.modelValue.transferData.overdrachten[id].bedrag = '';
        return;
      }
      this.$store.state.confirm.toggle({
        text: `<b>Let op!</b> U verwijdert uw kapitaaloverdracht.<br/><br/> Hierdoor kunnen wij
        geen PSK Overdrachtsformulier opstellen om de overdracht bij uw huidige partij in gang te
        zetten.`,
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            this.modelValue.transferData.overdrachten[id].bedrag = '';
          }
        },
      });
    },
  },
  data() {
    return {
      prefix: 'psk',
      overdrachtModal: false,
      index: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
  .error {
    color: #d9534f;
  }
  .modal .inputbox:first-child {
    margin-top: 10px !important;
  }
</style>
